import { Edit } from '@workwave-tidal/core/icons'

import { preview } from '@/components/form/preview'

import { getDayLabelFromIndex } from '@/intl'

import { usePersonalizationData } from '../hooks/usePersonalizationData'
import { weekDays } from '../weekDays'
import { useTexts } from './hooks/useTexts'

type Props = {
  onEdit: () => void
}

export function PersonalizationView(props: Props) {
  const { onEdit } = props

  const texts = useTexts()
  const [data] = usePersonalizationData()

  return (
    <preview.Root
      testId="personalization-view"
      data-trackid="personalization-view"
      applyPendingFitMapOnMount={false}
      rightBorder={false}
      header={
        <preview.Header
          title={texts.headerTitle}
          subtitle={texts.headerDescription}
          testId="personalization-view-header"
          data-trackid="personalization-view-header"
        >
          <preview.ActionBar>
            <preview.ActionBarItem
              icon={<Edit />}
              onClick={onEdit}
              label={texts.edit}
              disableWhenReadOnly={false}
              tooltip={texts.edit}
              testId="personalization__edit"
              data-trackid="personalization__edit"
            />
          </preview.ActionBar>
        </preview.Header>
      }
    >
      <preview.Field
        testId="personalization-week-startday"
        data-trackid="personalization-week-startday"
        label={
          texts.weekStartsWith.charAt(0).toUpperCase() + texts.weekStartsWith.slice(1).toLowerCase()
        }
      >
        {getDayLabelFromIndex(weekDays[data.weekStartsOn], 'long')}
      </preview.Field>
    </preview.Root>
  )
}
